import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CheckboxModel } from 'src/app/shared/models/common.model';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { OpEnum } from '../../../../shared/enums/op.enum';

@Component({
  selector: 'app-bonding',
  templateUrl: './bonding.component.html',
  styleUrls: ['./bonding.component.scss'],
})
export class BondingComponent implements OnInit {
  checkboxTerms: CheckboxModel = {
    id: '',
    label: '',
    checked: false,
    value: '',
  };
  documentInfo: DocumentModel;
  formGroup: FormGroup;
  showMor = false;
  noShare = false;
  statusValidation = false;
  terms: any;
  arrowIconDown = 'seta_baixo';
  arrowIconUp = 'seta_cima';
  products: any[] = [];
  cards: any[] = [{
    CARD: 'MASTERCARD',
  }];
  showModal: boolean;

  constructor(
    public copyService: CopyService,
    private abreCuentasService: AbreCuentasService,
    private headerService: HeaderService,
    private parametersService: ParametersService,
    private formBuilder: FormBuilder,
    private navigationService: NavigationService,
    private productLoaderService: ProductLoaderService,
    private bitacoraService: BitacoraService,
    private firmlyApprovedService: FirmlyApprovedService,
  ) { }

  ngOnInit() {
    this.headerService.show(true, true, true);
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.products = this.abreCuentasService.getProductsSelects();
    console.log(this.products);

    this.terms = {
      text: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].description,
      title: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].code,
      terms_id: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].id,
    };
    // data quemada
    this.documentInfo.firstname = 'Ana';
    // fin data quemada
    this.checkboxTerms = {
      id: '1',
      label: this.copyService.copies.detail_account_bonding_terms,
      checked: false,
      value: '1',
    };
  }
  showMore() {
    if (this.showMor) {
      this.showMor = false;
      return this.arrowIconUp;

    } else {
      this.showMor = true;
      return this.arrowIconDown;
    }
  }

  showIcon() {
    if (this.showMor) {
      return this.arrowIconUp;
    } else {
      return this.arrowIconDown;
    }
  }

  checkboxChange(event: any): void {
    this.checkboxTerms.checked = event.checked;
    this.abreCuentasService.setFiProperty('checkboxTerms', this.checkboxTerms);
    if (this.checkboxTerms.checked) {
      this.statusValidation = true;
    } else {
      this.statusValidation = false;
    }
  }
  async next() {
    if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
      this.registerBitacoraVinculations();
    }
    this.navigationService.navigateToGeneralInformation('130');
    // this.productLoaderService.show(this.copyService.copies.show_load_pco);
    // this.productLoaderService.hide();
    // if (this.abreCuentasService.getProductsSelects().length > 1) {
    // } else {
    //   this.navigationService.nextStep('200');
    // }
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  async registerBitacoraVinculations() {
    const productVincul = this.abreCuentasService.productsSelectVicul;
    const productClient = this.abreCuentasService.getClientProduct();
    if (productVincul) {
      const dataBitacora = this.copyService.copies.products_vinculation;
      let mergeProducts = '';
      productVincul.forEach(element => {
        mergeProducts += element;
      });
      const bitacoraEvent = dataBitacora[mergeProducts];
      await this.bitacoraService.saveDataInBitacora(bitacoraEvent);
      this.abreCuentasService.productsSelectVicul.pop();
      if (!productClient) {
        this.bitacoraService.saveDataInBitacora(dataBitacora['savingsAccount']);
      }
    }
  }
}
